import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import AlarmBarChart from '../cards/AlarmBarChart'
import AlarmTable from '../cards/AlarmTable.vue'
import DetailModal from './DetailModal'
import './alarm.less'
import { AlarmStatisticsServiceProxy, AlarmDetailDTO, AlarmStatisticsDTO,AlarmDetailDTOStatisticalMethod } from '@/service-proxies/app-v2/mdc.service-proxies'
import dayjs from 'dayjs';
import { exportAlarm } from '@/api/api';
const assp = new AlarmStatisticsServiceProxy()

@Component({
  components: {
    AlarmBarChart,
    AlarmTable,
    DetailModal
  }
})
export default class AlarmBody extends Vue {
  @Ref() detailModal : DetailModal
  @Prop({ default: () => ([]) }) tabsdData: Array<any>
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) columns: Array<any>
  @Prop({ default: () => ({}) }) searchData: AlarmStatisticsDTO
  @Prop({ default: false }) loading: Boolean
  showType: String = 'table'
  visible: Boolean = false
  checkItem = []
  defaultActiveKey = 0
  detailData = []
  detailVisible = false
  searchDataValue: AlarmDetailDTO = null
  total = 0
  dateType = 1 // 冷热数据
  dateTypeBool = 0 // 是否存在冷热数据 1：冷数据；2：热数据； 3：冷热数据并存
  totalAdd = false  // 是否总和相加
  istotalAdd = 0 // 是否已经相加
  viewMore = true


  handleShowTypeChange(value) {
    this.showType = value
    this.checkItem = []
    this.data.forEach(res => {
      res.checked = false
    })
  }

  changeTabs(value){
    this.defaultActiveKey = value
    this.$emit('changeTabs',value)
  }

  callback(val) {
    console.log(val);
  }
  checkDateType(day31,dayStart,dayEnd){
    let bool = 1
    if(day31 <= dayEnd && day31 >= dayStart) {
      bool = 2
      this.dateType = 2
      this.dateTypeBool = 3
    } else if(day31 > dayEnd){
      bool = 1
      this.dateType = 1
      this.dateTypeBool = 1
    } else if (day31 < dayStart){
      bool = 2
      this.dateType = 2
      this.dateTypeBool = 2
    }
    return bool
  }
  checkDate(statisticalMethod){
    let bool = 1
    this.dateTypeBool = 0
    const day31 = dayjs().subtract(31,'day').startOf('day').valueOf()
    if(statisticalMethod === 'WEEK'){
      const dayStart = dayjs(this.searchData.date).startOf('week').add(1,'day').valueOf()
      const dayEnd = dayjs(this.searchData.date).endOf('week').add(1,'day').valueOf()
      bool = this.checkDateType(day31,dayStart,dayEnd)
    } else if(statisticalMethod === 'MONTH'){
      const dayStart = dayjs(this.searchData.date).startOf('month').valueOf()
      const dayEnd = dayjs(this.searchData.date).endOf('month').valueOf()
      bool = this.checkDateType(day31,dayStart,dayEnd)
    } else {
      const daySearch = dayjs(this.searchData.date).startOf('day').valueOf()
      if(day31 > daySearch){
        bool = 1
        this.dateType = 1
        this.dateTypeBool = 1
      } else if (day31 <= daySearch){
        bool = 2
        this.dateType = 2
        this.dateTypeBool = 2
      }
    }
    return bool
  }
  
  handleView(item){
    this.detailData = []
    const statisticalMethod = this.searchData.statisticalMethod as any
    const data = new AlarmDetailDTO(
      {
        dataType: this.checkDate(statisticalMethod),
        date: new Date(this.searchData.date),
        month: this.searchData.month,
        shiftIndex: this.searchData.shiftIndex,
        statisticalMethod: statisticalMethod,
        week: this.searchData.week,
        workStationId: item.workStation.workStationId,
        year: this.searchData.year
      }
    )
    this.searchDataValue = data
    const current = (this.checkDate(statisticalMethod) == 2) ? 0 : 1
    assp.alarmDetail(data,current,10).then(res =>{
      this.detailData = res.records
      this.total = Number(res.total)
      this.detailVisible = true
      if(this.dateTypeBool == 3 && Number(res.total) == 0){
        this.pageIndexChange(1)
        this.detailModal.currt = 1
      }
    })
  }

  pageIndexChange(value){
    if(this.dateTypeBool === 3){
      if(!this.totalAdd && this.total == this.detailData.length){
        this.searchDataValue.dataType = 1
        this.totalAdd = true
        this.istotalAdd += 1
        value = 1
        this.detailModal.currt = 1
      } else if(this.total == this.detailData.length){
        this.viewMore = false
        this.$message.warning(this.$t('page_mdc_alarm_end_more'))
        return
      }
    } else {
      if(this.total == this.detailData.length){
        this.viewMore = false
        this.$message.warning(this.$t('page_mdc_alarm_end_more'))
        return
      }
    }
    if(this.searchDataValue.dataType == 2){
      value -= 1
    }
    assp.alarmDetail(this.searchDataValue,value,10).then(res =>{
        this.detailData= [...this.detailData,...res.records]
        if(this.istotalAdd === 1){
          this.istotalAdd += 1
          this.total += Number(res.total)
        }
        if(this.total == this.detailData.length){
          this.viewMore = false
          this.$message.warning(this.$t('page_mdc_alarm_end_more'))
        }
    })
  }
  closeModal(){
    this.detailVisible = false
    this.total = 0
    this.dateType = 1 // 冷热数据
    this.dateTypeBool = 0 // 是否存在冷热数据 1：冷数据；2：热数据； 3：冷热数据并存
    this.totalAdd = false  // 是否总和相加
    this.istotalAdd = 0 // 是否已经相加
    this.detailModal.currt = 1
    this.viewMore = true
  }

  renderLoading(){
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 34px" spin />
        </a-spin>
      </div>
    )
  }

  export(){
    this.$emit('export')
  }

  render() {
    return (
      <blank-view>
        <div slot="action">
          <a-button type="primary" onClick={() => this.export()}>{this.$t('page_product_export')}</a-button>
        </div>
        <div style="height: 100%">
          <div style="width: 100%">
            <a-tabs
              active-key={this.defaultActiveKey}
              tab-position={'top'}
              onPrevClick={this.callback}
              onNnextClick={this.callback}
              onChange={value => this.changeTabs(value)}
            >
              {this.tabsdData.length > 0 ? this.tabsdData.map((res,index) =>{return (<a-tab-pane key={index} tab={res.title}></a-tab-pane>)}) : null}
            </a-tabs>
          </div>
          <div class="alarm-content">
            {this.loading ? this.renderLoading() : this.data.length > 0 ? this.data.map((item, index) => {
              return (
                <div style="width:100%;">
                  <div style="width:100%; display:flex;align-items:center;justify-content: space-between;padding: 0 8px; margin-bottom: 8px;">
                    <span style="font-size: 24px; font-weight: bold">{item.workStation.workStationName}</span>
                    <a-button type="primary" onClick={() => this.handleView(item)}>{ this.$t('page_alarm_viewdetail') }</a-button>
                  </div>
                  <a-row>
                    <a-col style="padding: 0 16px;" span={9}>
                      <alarm-table dataValue={ item }></alarm-table>
                    </a-col>
                    <a-col span={15}>
                      <div style="width:100%;">
                        <alarm-bar-chart columns={this.columns} dataValue={ item }></alarm-bar-chart>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              )
            }) : <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>}
          </div>
          <detail-modal
            ref="detailModal"
            visible={this.detailVisible}
            data={this.detailData}
            istotalAdd={this.istotalAdd}
            onClose={() => this.closeModal()}
            viewMore={this.viewMore}
            onChange={(value) => this.pageIndexChange(value)}
          >
          </detail-modal>
        </div>
      </blank-view>
    )
  }
}